import 'vite/modulepreload-polyfill';

import '../css/main.css';

import '../js/cart-button.js';
import '../js/cart-drawer.js';
import '../js/localization-modal.js';

// Your JavaScript code here
console.log('Theme loaded!');